<template>
  <div class="calendar-container">
    <v-card class="calendar-controls elevation-2 mb-6">
      <v-container fluid>
        <v-layout row wrap align-center>
          <v-flex lg4 md4 sm12 xs12>
            <v-dialog ref="dialog" persistent v-model="modal1" lazy full-width width="290px"
                      :return-value.sync="calendar.start_date">
              <v-text-field slot="activator"
                            label="Start Date"
                            v-model="calendar.start_date"
                            readonly
                            prepend-icon="event"
                            class="date-picker-input"></v-text-field>
              <v-date-picker v-model="calendar.start_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal1 = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog.save(calendar.start_date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>

          <v-flex lg4 md4 sm12 xs12>
            <v-dialog ref="dialog1" persistent v-model="modal2" lazy full-width width="290px"
                      :return-value.sync="calendar.end_date">
              <v-text-field slot="activator"
                            label="End Date"
                            v-model="calendar.end_date"
                            readonly
                            prepend-icon="event"
                            class="date-picker-input"></v-text-field>
              <v-date-picker :min="calendar.start_date" v-model="calendar.end_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog1.save(calendar.end_date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>

          <v-flex lg4 md4 sm12 xs12>
            <v-btn color="primary"
                   @click="getData()"
                   block
                   :loading="this.$store.state.LoadingStore.loading"
                   class="get-dates-btn">
              Get Selected Dates
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <div class="calendar-table-container">
      <v-card class="elevation-2 calendar-card">
        <div class="calendar-scroll-wrapper">
          <table class="calendar-table">
            <thead class="calendar-header">
              <tr>
                <th class="header-day">DAYS</th>
                <th v-for="(date, key) in getWeek"
                    :class="{ 'weekend-day': getDay(date) }"
                    :key="key"
                    class="header-date">
                  <div class="date-display">
                    <div class="day-name">{{ formatDate(date) }}</div>
                    <div class="full-date">{{ date }}</div>
                  </div>
                </th>
              </tr>
            </thead>

            <tbody class="calendar-body">
              <div v-if="getConservationFeeCalendar.length <= 0 &&
                        getVehicleFeeCalendar.length <= 0"
                   class="loading-indicator">
                <v-progress-circular indeterminate color="#74a533" size="64"></v-progress-circular>
              </div>

              <tr>
                <th class="service-name header-row">
                  <div class="component-name">CAPACITY TAKEN</div>
                </th>
                <td v-for="(date, key) in getWeek"
                    :class="{ 'weekend-cell': getDay(date) }"
                    :key="key">
                </td>
              </tr>

              <tr>
                <th class="service-name conservation-service">
                  <div class="component-name">CONSERVATION RESIDENCIES AND VEHICLES</div>
                </th>
                <td v-for="(date, key) in getWeek"
                    :class="{ 'weekend-cell': getDay(date) }"
                    :key="key">
                </td>
              </tr>

              <template v-if="getConservationFeeCalendar.length > 0">
                <tr v-for="(conservation, key) in getConservationFeeCalendar" :key="'conservation' + key">
                  <th class="service-name conservation-service">
                    <div class="component-name">{{ conservation.payment_person.toUpperCase() }}</div>
                  </th>
                  <td v-for="(slot, key) in conservation.conservancy_fee_details"
                      :key="key"
                      :class="{ 'weekend-cell': getDay(slot.date) }">
                    <v-btn v-if="slot.conservancy_fee_count === 0"
                           color="primary"
                           small
                           @click="getConservationDetails(conservation.payment_public_id, slot.date)"
                           class="slot-btn">
                      {{ slot.conservancy_fee_count }}
                    </v-btn>
                    <v-btn v-if="slot.conservancy_fee_count > 0"
                           color="default"
                           small
                           @click="getConservationDetails(conservation.payment_public_id, slot.date)"
                           class="slot-btn">
                      {{ slot.conservancy_fee_count }}
                    </v-btn>
                  </td>
                </tr>
              </template>

              <template v-if="getVehicleFeeCalendar.length > 0">
                <tr v-for="(vehicle, key) in getVehicleFeeCalendar" :key="'vehicle' + key">
                  <th class="service-name vehicle-service">
                    <div class="component-name">{{ vehicle.vehicle_charge_category.toUpperCase() }}</div>
                  </th>
                  <td v-for="(slot, key) in vehicle.vehicle_details"
                      :key="key"
                      :class="{ 'weekend-cell': getDay(slot.date) }">
                    <v-btn v-if="slot.vehicle_count === 0"
                           color="primary"
                           small
                           @click="getVehicleDetails(vehicle.vehicle_charge_public_id, slot.date)"
                           class="slot-btn">
                      {{ slot.vehicle_count }}
                    </v-btn>
                    <v-btn v-if="slot.vehicle_count > 0"
                           color="default"
                           small
                           @click="getVehicleDetails(vehicle.vehicle_charge_public_id, slot.date)"
                           class="slot-btn">
                      {{ slot.vehicle_count }}
                    </v-btn>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </v-card>
    </div>

    <v-bottom-sheet v-model="sheet" class="bookings-sheet">
      <v-card>
        <v-card-title class="sheet-header">
          BOOKINGS
          <v-spacer></v-spacer>
          <v-btn icon @click="sheet = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <bookings></bookings>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
  import Bookings from './Bookings/Bookings'

  export default {
    name: 'ConservationVehicleCalendar',
    components: {
      Bookings
    },
    data() {
      return {
        modal1: false,
        modal2: false,
        today: this.$moment.now(),
        calendar: {
          start_date: this.$moment(this.today).format('YYYY-MM-DD'),
          end_date: this.$moment(this.today).add(5, 'days').format('YYYY-MM-DD')
        },
        sheet: false
      }
    },
    created() {
      this.$store.dispatch('get_conservation_vehicle_calendar', this.calendar)
    },
    methods: {
      getConservationDetails(conservationPublicId, date) {
        this.sheet = true
        var data = {
          guest_id: conservationPublicId,
          date: this.$moment(date).format('YYYY-MM-DD')
        }
        this.$store.dispatch('get_conservation_bookings', data)
      },
      getVehicleDetails(vehiclePublicId, date) {
        this.sheet = true
        var data = {
          vehicle_id: vehiclePublicId,
          date: this.$moment(date).format('YYYY-MM-DD')
        }
        this.$store.dispatch('get_vehicle_bookings', data)
      },
      formatDate(date) {
        return this.$moment(date).format('ddd').toUpperCase()
      },
      getDay(day) {
        var date = this.$moment(day).weekday()
        return (date === 6) || (date === 0)
      },
      getData() {
        this.$store.dispatch('loading_true')
        this.$store.dispatch('get_conservation_vehicle_calendar', this.calendar)
      }
    },
    computed: {
      getWeek() {
        var start = this.calendar.start_date
        var a = this.$moment(this.$moment(this.calendar.start_date).format('YYYY, MM, DD'))
        var b = this.$moment(this.$moment(this.calendar.end_date).format('YYYY, MM, DD'))
        var max = b.diff(a, 'days')
        var days = []
        for (var i = 0; i <= max; i++) {
          var day = this.$moment(start).add(i, 'days').format('DD MMM, YYYY')
          days.push(day)
        }
        return days
      }
    }
  }
</script>

<style scoped>
  .calendar-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  }

  .calendar-controls {
    border-radius: 12px !important;
    padding: 15px;
    background: #ffffff;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12) !important;
    border: 1px solid rgba(0,0,0,0.05);
  }

  .date-picker-input {
    margin-top: 8px;
  }

  .get-dates-btn {
    margin-top: 8px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 14px;
    height: 48px;
    box-shadow: 0 4px 12px rgba(116, 165, 51, 0.3);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    background-color: #74a533 !important;
  }

    .get-dates-btn:hover {
      box-shadow: 0 6px 16px rgba(116, 165, 51, 0.4);
      transform: translateY(-1px);
    }

  .calendar-table-container {
    margin-top: 20px;
    overflow-x: auto;
  }

  .calendar-card {
    border-radius: 12px !important;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12) !important;
    border: 1px solid rgba(0,0,0,0.05);
  }

  .calendar-scroll-wrapper {
    overflow-x: auto;
    padding: 10px;
  }

  .calendar-table {
    width: 100%;
    min-width: 800px;
    border-collapse: separate;
    border-spacing: 0 4px;
  }

  .calendar-header {
    background-color: #74a533;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .header-day {
    min-width: 150px;
    padding: 16px;
    font-weight: 600;
    text-align: left;
    color: white;
    font-size: 16px;
    letter-spacing: 1px;
    position: sticky;
    left: 0;
    z-index: 2;
    background-color: #74a533;
  }

  .header-date {
    min-width: 100px;
    padding: 12px 8px;
    text-align: center;
  }

  .date-display {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .day-name {
    font-weight: 600;
    font-size: 15px;
    color: white;
    letter-spacing: 1px;
  }

  .full-date {
    font-size: 12px;
    color: rgba(255,255,255,0.8);
    margin-top: 4px;
  }

  .calendar-body {
    background-color: transparent;
  }

  .service-name {
    padding: 12px 10px;
    font-weight: 600;
    text-align: left;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    letter-spacing: 1px;
    min-width: 150px;
    max-width: 150px;
    position: sticky;
    left: 0;
    z-index: 1;
  }

  .component-name {
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.4;
    padding: 4px 0;
    font-size: 13px;
  }

  .header-row {
    background-color: #74a533;
    color: white;
  }

  .conservation-service {
    background: linear-gradient(135deg, #fdb813 0%, #f39c12 100%);
    color: white;
  }

  .vehicle-service {
    background: linear-gradient(135deg, #520036 0%, #8e44ad 100%);
    color: white;
  }

  .weekend-day {
    background-color: #5d8a2a;
  }

  .weekend-cell {
    background-color: #FFCDD2;
  }

  .slot-btn {
    min-width: 40px;
    margin: 2px;
    font-weight: 600;
    transition: all 0.3s ease;
    height: 32px !important;
    font-size: 13px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

    .slot-btn:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }

  .loading-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    width: 100%;
  }

  .bookings-sheet {
    z-index: 1000;
  }

  .sheet-header {
    font-size: 24px;
    padding: 16px;
    color: #2c3e50;
    letter-spacing: 1px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  }

  @media (max-width: 960px) {
    .calendar-container {
      padding: 10px;
    }

    .header-day,
    .service-name {
      min-width: 120px;
      font-size: 13px;
      padding: 8px 10px;
    }

    .header-date {
      min-width: 80px;
    }
  }

  @media (max-width: 600px) {
    .calendar-controls {
      padding: 10px;
    }

    .date-picker-input,
    .get-dates-btn {
      margin-top: 0;
      margin-bottom: 10px;
    }

    .service-name {
      min-width: 100px;
      max-width: 100px;
      font-size: 12px;
      padding: 8px 6px;
    }

    .component-name {
      font-size: 11px;
    }
  }
</style>
